module.exports = __webpack_public_path__ + "static/media/zq_ysbq_fm.a8e67cc8.jpeg";